import reducer from "./reducer";
export { default as Languages } from "./components/index";
export { default as languagesReducerName } from "./constants";
export default reducer;
